export const handleApiResponse = async (
  response,
  setSessionExpired,
) => {
  if (response?.status === 403) {
    localStorage.clear();

    if (setSessionExpired) {
      setSessionExpired(true);
    }
    return null;
  }

  return await response.json();
};